// TODO: Эту функцию можно вынести в глобальный utils

import { sleepWhile } from '@/core/utils/system';

/**
 * Проверка нахождения компонента в состояние загрузки
 * @param component
 */
export const checkComponentIsLoading = (component: any) => {
	return component?.name === 'AsyncComponentWrapper' && !component?.__asyncResolved;
};

/**
 * Презагрузить компонент
 *
 * Некоторое время ожидает загрузку компонента, прежде чем завершит работу
 */
export const preResolveComponent = async (component: any, condition: Function) => {
	if (component?.name !== 'AsyncComponentWrapper') return;
	if (component?.__asyncResolved) return;

	component.__asyncLoader();

	await sleepWhile(() => {
		return condition() && checkComponentIsLoading(component);
	}, 200);
};
